import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
  setTotalSlides,
} from "../store/slices/slides";

function SlideWrapper({ children }) {
  const dispatch = useDispatch();
  const { currentSlide } = useSelector((state) => state.slides);
  const flattenedChildren = [];

  children?.forEach((k) => {
    if (k.constructor === Array) {
      return k.forEach((c) => flattenedChildren.push(c));
    } else {
      return flattenedChildren.push(k);
    }
  });

  useEffect(() => {
    dispatch(setTotalSlides(flattenedChildren.length));
  }, [flattenedChildren]);

  return (
    <div className="h-full">
      {flattenedChildren.map((k, index) => {
        if (index == currentSlide && k.props && k.props?.isDisabled) {
          dispatch(incrementCurrentSlide());
          dispatch(incrementPeekSlide());
        }

        return (
          <div
            key={index}
            style={{
              display: index == currentSlide ? "inherit" : "none",
              height: "100%",
            }}
          >
            {React.cloneElement(k, { isVisible: index == currentSlide })}
          </div>
        );
      })}
    </div>
  );
}

export default SlideWrapper;
